import { Col, Row, Table, Tag } from "antd";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { MdOpenInNew, MdOutlineDeleteOutline } from "react-icons/md";
import Pagination from "shared/components/Pagination";
import { COLORS } from "shared/style/colors";
import { SCREENS } from "utils/constants";

const View = ({ data, count, setValues, skip, list }) => {
  const navigate = useNavigate();

  const columns = [
    {
      title: list.NAME,
      dataIndex: "description",
      render: (description) => description || "—",
    },
    {
      title: list.PROCESS,
      dataIndex: "status",
      render: (status) => status?.process?.name || "—",
    },
    {
      title: list.STATUS,
      dataIndex: "status",
      render: (status) => status?.name || "—",
    },
    {
      title: list.PUBLISHED_VERSION,
      dataIndex: "currentPublishedVersion",
      render: (version) =>
        version ? (
          <Tag color="green">v{version.versionNumber}</Tag>
        ) : (
          <Tag color="default">{list.NO_VERSION}</Tag>
        ),
    },
    {
      title: list.PUBLICATION,
      dataIndex: "currentPublishedVersion",
      render: (version) => {
        if (!version) return <Tag color="default">{list.NOT_PUBLISHED}</Tag>;
        if (version.status === "published") {
          return <Tag color="green">{list.PUBLISHED}</Tag>;
        }
        if (version.status === "archived") {
          return <Tag color="red">{list.ARCHIVED}</Tag>;
        }
        if (version.status === "draft") {
          return <Tag color="orange">{list.DRAFT}</Tag>;
        }
        if (version.status === "inReview") {
          return <Tag color="blue">{list.IN_REVIEW}</Tag>;
        }
        return <Tag>{version.status}</Tag>;
      },
    },
    {
      title: list.ACTIONS,
      dataIndex: "id",
      align: "right",
      render: (id) => (
        <Row gutter={8} justify="end" align="center" wrap={false}>
          <Col
            onClick={() =>
              navigate(`${SCREENS.PRIVATE.ADMIN.SCREEN_STUDIOS.DETAIL.path}/${id}`)
            }
          >
            <MdOpenInNew size={24} color={COLORS.C_PRIMARY} />
          </Col>
          <Col
            onClick={() =>
              navigate(`${SCREENS.PRIVATE.ADMIN.SCREEN_STUDIOS.DELETE.path}/${id}`)
            }
          >
            <MdOutlineDeleteOutline size={24} color={COLORS.C_DANGER} />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        className="table__wrapper"
        columns={columns}
        rowKey="id"
        pagination={false}
        scroll={{ x: true }}
      />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
};

View.propTypes = {
  data: PropTypes.array,
  count: PropTypes.number,
  setValues: PropTypes.func,
  skip: PropTypes.number,
  list: PropTypes.object.isRequired,
};

View.defaultProps = {
  data: [],
  count: 0,
  setValues: () => {},
  skip: 0,
};

export default View;
